var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "picker-list",
        staticStyle: { "max-height": "650px", "overflow-y": "scroll" },
        attrs: { id: "pickerList" },
      },
      _vm._l(_vm.list, function (item) {
        return _c("div", { staticClass: "picker-item" }, [
          _c("div", [
            _c("strong", [_vm._v(_vm._s(item.name))]),
            _c("small", [_vm._v(_vm._s(item.educationQualification))]),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn small",
              class: item.isAvailable ? "primary" : "",
              attrs: { "data-pick-staff": item.fullName },
              on: {
                click: function ($event) {
                  return _vm.select(item)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("actions.select")))]
          ),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }